import React from "react";
import Lottie from "react-lottie";
import PaymentProcessingIcon from "./../../../assets/lotties/loader.json";
import "./loader.scss";

export interface ILoaderProps {
  fullscreen?: boolean;
}

const Loader = (props?: ILoaderProps) => {
  const { fullscreen } = props || {};

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: PaymentProcessingIcon,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className={`lottie-loader ${fullscreen ? "fullscreen-loader" : ""}`}>
      <Lottie
        title="Loading"
        options={defaultOptions}
        height={150}
        width={150}
      />
    </div>
  );
};

export default Loader;
